import { BackendRoute } from '../config/index';
import ApiService from '../services/api-service.util';

export type RevokedAccessSigner = {
  fullName: string;
  id: string;
};

export const fetchRevokedAccessSigners = async (
  stakeholderIds: string[],
): Promise<RevokedAccessSigner[]> => {
  const uniqueIds = Array.from(new Set(stakeholderIds.filter(Boolean)));
  if (uniqueIds.length === 0) {
    return [];
  }

  const response = await ApiService.post<{ signers: RevokedAccessSigner[] }>(
    { endpoint: BackendRoute.SIGNATURES_REVOKED_ACCESS_SIGNERS },
    { body: { stakeholderIds: uniqueIds } },
  );

  return response.signers ?? [];
};
